import * as API from "../apiConfig";

export function WhatsAppIcon({ size = 16 }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
        >
            <path d="M19.05 4.94A9.83 9.83 0 0 0 12.03 2C6.57 2 2.13 6.44 2.13 11.9c0 1.75.46 3.46 1.33 4.97L2 22l5.28-1.38a9.86 9.86 0 0 0 4.74 1.21h.01c5.46 0 9.9-4.44 9.9-9.9a9.8 9.8 0 0 0-2.88-6.99Zm-7.02 15.22h-.01a8.2 8.2 0 0 1-4.17-1.14l-.3-.18-3.13.82.84-3.05-.2-.31a8.23 8.23 0 0 1-1.27-4.39c0-4.56 3.71-8.27 8.27-8.27a8.2 8.2 0 0 1 5.85 2.43 8.2 8.2 0 0 1 2.42 5.84c0 4.57-3.71 8.28-8.27 8.28Zm4.53-6.19c-.25-.12-1.47-.72-1.7-.8-.23-.09-.4-.13-.57.12-.17.25-.66.8-.8.96-.15.17-.29.19-.54.06a6.72 6.72 0 0 1-1.98-1.22 7.4 7.4 0 0 1-1.37-1.71c-.14-.25-.01-.38.11-.5.11-.11.25-.29.38-.43.12-.15.17-.25.25-.42.08-.17.04-.31-.02-.43-.06-.12-.56-1.34-.77-1.84-.2-.48-.4-.41-.57-.42h-.48c-.17 0-.43.06-.66.31-.23.25-.86.84-.86 2.06 0 1.22.88 2.4 1.01 2.56.12.17 1.72 2.62 4.17 3.67.58.25 1.03.4 1.38.51.58.18 1.1.15 1.52.09.46-.07 1.47-.6 1.68-1.18.21-.58.21-1.08.15-1.18-.06-.09-.22-.15-.46-.27Z" />
        </svg>
    );
}

export function buildOrderShareText(order, prefix) {
    const resolvedOrder = order || {};
    const resolvedStage =
        resolvedOrder.currentStage === "Delivered"
            ? resolvedOrder.mode || "Delivered"
            : resolvedOrder.currentStage || "Pending";

    return [
        "*Order Update*",
        "",
        resolvedOrder.id ? `- Order ID: ${prefix}-${resolvedOrder.orderId}` : "",
        resolvedOrder.description ? `- Description: ${resolvedOrder.description}` : "",
        resolvedOrder.height && resolvedOrder.width
            ? `- Size: H-${resolvedOrder.height} x W-${resolvedOrder.width}`
            : "",
        resolvedOrder.quantity ? `- Quantity: ${resolvedOrder.quantity}` : "",
        `- Current Stage: **${resolvedStage}**`,
    ]
        .filter(Boolean)
        .join("\n");
}

export async function shareOrderOnWhatsApp({ clientId, order, getRequestHeaders }) {
    if (!clientId) {
        throw new Error("Client not available for this order.");
    }

    const response = await fetch(`${API.CLIENTS_API_URL}/${clientId}`, {
        method: "GET",
        headers: getRequestHeaders(),
    });
    const data = await response.json();

    if (!response.ok) {
        throw new Error(data.message || "Unable to fetch client details");
    }

    const client = data?.client || data;
    const rawPhone = String(client?.phoneNumber || "").trim();
    const phoneNumber = rawPhone.replace(/\D/g, "");
    const clientName = client.clientName;
    const prefix = (clientName || '').slice(0, 3).toUpperCase() || 'BIL';
    if (!phoneNumber) {
        throw new Error("Client phone number is unavailable");
    }

    const shareText = buildOrderShareText(order,prefix);
    // const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(shareText)}`;
    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(shareText)}`;
    window.open(whatsappUrl, "_blank", "noopener,noreferrer");
}

export function ShareOnWhatsAppIconButton({ onClick, label }) {
    return (
        <button
            type="button"
            className="btn btn-outline-success btn-sm"
            aria-label={label}
            title="Share on WhatsApp"
            onClick={onClick}
        >
            <WhatsAppIcon size={16} />
        </button>
    );
}

export function OrderShareSuccessModal({ show, message, onClose, onShare }) {
    if (!show) {
        return null;
    }

    return (
        <div
            className="modal fade show d-block"
            style={{ background: "rgba(15, 23, 42, 0.45)", zIndex: 2050 }}
            onClick={onClose}
        >
            <div
                className="modal-dialog modal-dialog-centered"
                onClick={(event) => event.stopPropagation()}
            >
                <div className="modal-content border-0 shadow-lg rounded-4">
                    <div className="modal-body p-4 p-md-5 text-center">
                        <div className="d-flex justify-content-end">
                            <button
                                type="button"
                                className="btn-close"
                                aria-label="Close"
                                onClick={onClose}
                            ></button>
                        </div>

                        <div className="mb-3 d-flex align-items-center justify-content-center gap-2 text-success fw-semibold fs-5">
                            <span
                                className="spinner-grow spinner-grow-sm"
                                role="status"
                                aria-hidden="true"
                            ></span>
                            <span>{message || "Order updated successfully"}</span>
                        </div>

                        <p className="text-muted mb-4">
                            Order details are updated and ready to share.
                        </p>

                        <button
                            type="button"
                            className="btn btn-success btn-lg px-4 py-2 d-inline-flex align-items-center gap-2"
                            onClick={onShare}
                        >
                            <WhatsAppIcon size={20} />
                            <span>Share on WhatsApp</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
